import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function passwordStrengthValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) {
      return null; // Return null if the control is empty
    }

    const hasUpperCase = /[A-Z]/.test(value);
    const hasNumeric = /[0-9]/.test(value);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value);
    const minLength = value.length >= 8;

    const valid = hasUpperCase && hasNumeric && hasSpecialChar && minLength;

    return valid
      ? null
      : { passwordStrength: true }; // Return error if validation fails
  };
}
